import DOMPurify from 'dompurify';
import config from 'config';

const {
	HOST: { UI_URL_BASE }
} = config;

let translations = {};
let fallbackTranslations = {};

export const loadTranslations = async (lang = 'en', modules = []) => {
	translations = {};
	fallbackTranslations = {};

	// Load locale translations
	await Promise.all(
		modules.map(async (module) => {
			try {
				const response = await fetch(
					`${UI_URL_BASE}/locales/${module}.${lang}.json`
				);
				const data = await response.json();
				translations = { ...translations, ...data };
			} catch (error) {
				console.error(
					`Error loading translations for module: ${module}, lang: ${lang}`,
					error
				);
			}
		})
	);

	if (lang !== 'en') {
		// Load fallback translations (English)
		await Promise.all(
			modules.map(async (module) => {
				try {
					const response = await fetch(`${UI_URL_BASE}/locales/${module}.en.json`);
					const data = await response.json();
					fallbackTranslations = { ...fallbackTranslations, ...data };
				} catch (error) {
					console.error(
						`Error loading fallback translations for module: ${module} and lang: ${lang}`,
						error
					);
				}
			})
		);
	}

	// Freeze the translation objects to prevent mutation
	Object.freeze(translations);
	Object.freeze(fallbackTranslations);
	console.log('INFO: Translations loaded:', lang);
};

export const i18n = (key, values = {}) => {
	const translation = translations[key] || fallbackTranslations[key] || key;

	// Replace dynamic values in the translation string
	return Object.keys(values).reduce((str, valueKey) => {
		const value = values[valueKey];
		return str.replace(new RegExp(`{${valueKey}}`, 'g'), value);
	}, translation);
};

export const i18nHtml = (key, values = {}) => {
	return DOMPurify.sanitize(i18n(key, values));
};
